/** 注入 IWrapper 中定义的js和css */
function insertResource({ css = [], script = [] }: {css:string[], script:string[]}) {
  type InsertResult = {
    uri: string
    result: boolean
  }

  function addAttrsToElement(attrs: Partial<HTMLScriptElement & HTMLLinkElement>, el: HTMLElement) {
    let attrKeys = Object.keys(attrs)
    attrKeys.forEach(function (attrKey) {
      let attrValue = attrs[attrKey]
      el.setAttribute(attrKey, attrValue)
    })
  }

  function removeElm(target: HTMLHeadElement, elm: HTMLElement, err: boolean) {
    if (target && elm) {
      err && target.removeChild(elm)
      elm.onload = null
      elm.onerror = null
    }
  }

  const DEFAULT_ATTRIBUTES = {
    type:    'text/javascript',
    charset: 'utf-8',
    async:   true,
    timeout: 12 * 1000
  }
  const DEFAULT_ATTRIBUTES_STYLE = {
    rel:     'stylesheet',
    async:   true,
    timeout: 12 * 1000
  }

  return new Promise(resolve => {

    const headDom = document.head

    const promises: Promise<InsertResult>[] = []

    // 插入css
    if (css.length) {
      promises.push(...css.map(uri => (
        checkExistsTag(uri, true) ? Promise.resolve({ uri, result: true }) :
          new Promise<InsertResult>(resolve => {
            const styleElm = document.createElement('link')
            addAttrsToElement(DEFAULT_ATTRIBUTES_STYLE, styleElm)
            styleElm.href = uri
            styleElm.onerror = err => {
              resolve({ uri, result: false })
              styleElm && removeElm(headDom, styleElm, true)
            }
            styleElm.onload = () => {
              resolve({ uri, result: true })
              removeElm(headDom, styleElm, false)
            }
            headDom.insertBefore(styleElm, headDom.firstChild!)
          })
      )))
    }

    // 插入js
    if (script.length) {
      promises.push(...script.map(uri => (
        checkExistsTag(uri) ? Promise.resolve({ uri, result: true }) :
          new Promise<InsertResult>(resolve => {
            let scriptElm = document.createElement('script')
            addAttrsToElement(DEFAULT_ATTRIBUTES, scriptElm)
            scriptElm.src = uri
            scriptElm.onerror = err => {
              resolve({ uri, result: false })
              removeElm(headDom, scriptElm, true)
            }
            scriptElm.onload = () => {
              resolve({ uri, result: true })
              removeElm(headDom, scriptElm, false)
            }
            headDom.appendChild(scriptElm)
          })
      )))
    }
    // if (script.length) {
    //   promises.push(...script.map(uri => (
    //     new Promise<InsertResult>(resolve => {
    //       // 移除旧的<script>标签
    //       const oldScript = document.querySelector(`script[src="${uri}"]`)
    //       if (oldScript) {
    //         oldScript.parentNode!.removeChild(oldScript)
    //       }
  
    //       // 插入新的<script>标签
    //       let scriptElm = document.createElement('script')
    //       addAttrsToElement(DEFAULT_ATTRIBUTES, scriptElm)
    //       scriptElm.src = uri
    //       scriptElm.onerror = err => {
    //         resolve({ uri, result: false })
    //         removeElm(headDom, scriptElm, true)
    //       }
    //       scriptElm.onload = () => {
    //         resolve({ uri, result: true })
    //         removeElm(headDom, scriptElm, false)
    //       }
    //       headDom.appendChild(scriptElm)
    //     })
    //   )))
    // }

    resolve(Promise.all(promises))

  })
}

/**
 * 检查标签是否存在
 * @param url 
 * @param isStyle 
 */
function checkExistsTag(url: string, isStyle = false) {
  return document.querySelector(`[${isStyle ? 'href' : 'src'}="${url}"]`)
}

export {
  insertResource
}